export const StyledReactQuill = (error: boolean) => ({
  width: '100%',
  height: '100%',
  border: error ? '1px solid #D32F2F' : '',
  borderRadius: 4
});